var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChildSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97,
    height: 35,
    viewBox: "0 0 97 35",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "childSingle-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 35,
    transform: "translate(-2.657 1.126)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "childSingle",
    transform: "translate(2.657 -1.126)",
    clipPath: "url(#childSingle-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.46,39.941c-2.282-5.559-8.874-6.028-11.73-7.413A10.907,10.907,0,0,1,56.574,22.48c0-3.953,2.758-7.155,6.156-7.155s6.156,3.205,6.156,7.155A10.907,10.907,0,0,1,62.73,32.528c-2.86,1.385-9.448,1.854-11.73,7.413",
    transform: "translate(-16.887 -4.815)",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildSingle);
export default __webpack_public_path__ + "static/media/childSingle.64a7976ddc789bf221f19ed12112fe3d.svg";
export { ForwardRef as ReactComponent };